import React from "react";
import { roundTo } from "../../../utils/mathUtils";
import { getSplitsScoutingPrintFields } from "../../../config/leaderboards/columns/splits";

function formatCell(kind, value) {
  if (value == null || value === "") return "—";
  if (kind === "r3") return roundTo(Number(value), 3);
  if (kind === "num") return value;
  return value;
}

export function SplitsReportPrintTable(props) {
  const { rows, kind } = props;
  const fields = getSplitsScoutingPrintFields(kind === "pitcher" ? "pitcher" : "batter");

  return (
    <div className="w-full overflow-x-auto">
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 8,
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <thead>
          <tr style={{ background: "#f8fafc" }}>
            {fields.map((f) => (
              <th
                key={f.field}
                style={{
                  padding: "3px 4px",
                  textAlign: f.kind === "text" ? "left" : "center",
                  fontSize: 7,
                  fontWeight: 600,
                  color: "#374151",
                  whiteSpace: "nowrap",
                  borderBottom: "2px solid #d1d5db",
                }}
              >
                {f.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={row.player_id ?? ri} style={{ background: ri % 2 === 0 ? "#fff" : "#f9fafb" }}>
              {fields.map((f) => (
                <td
                  key={f.field}
                  style={{
                    padding: "3px 4px",
                    textAlign: f.kind === "text" ? "left" : "center",
                    fontSize: f.field === "player_name" ? 9 : 8,
                    fontWeight: f.field === "player_name" ? 600 : 400,
                    color: f.field === "player_name" ? "#1e3a8a" : "#111827",
                    borderBottom: "1px solid #f3f4f6",
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatCell(f.kind, row[f.field])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
